// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"04e33b59","455":"e2539149","977":"fa6ed0c8"}[chunkId] + ".chunk.js";
};